import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'

export function useFindCustomerByBookingId() {
    const query = useRpQuery()
    return async (id: string) => {
        const data = await query(
            graphql(/** GraphQL */ `
                query findCustomerByBookingId($id: ID!) {
                    customerBookingId(bookingId: $id) {
                        commaName
                    }
                }
            `),
            {
                id: id
            }
        )

        if (data === null) {
            return null
        } else {
            return data.customerBookingId
        }
    }
}
